import React, { useEffect, useState } from 'react';
import Drawer from "@mui/material/Drawer";
import { useForm } from "react-hook-form";
import { useMutation, useLazyQuery, useQuery } from '@apollo/client';
import { LIST_MENU } from '../../../Graphql/queries';
import { CREATE_MENU_WITH_ADDONS } from '../../../Graphql/mutations';
import { toggleSnackbar } from "../../../ReactiveVariables/index";

import {
  Button,
  TextField
} from "@mui/material";
import { userDeatils } from "../../../ReactiveVariables/index";
import { useNavigate } from 'react-router-dom';
import { useReactiveVar } from "@apollo/client";

export default function ImportMenu(props) {
  const user = useReactiveVar(userDeatils);

  const [ menuToImportCatererId, setMenuToImportCatererId ] = useState(null);
  const [ enabled, setEnabled ] = useState(false);
  const [ menu, setMenu ] = useState(null);
  const [ fromCaterer, setFromCaterer ] = useState(null);
  const [importProgress, setImportProgress] = useState([]);

  const { data, refetch } = useQuery(LIST_MENU, {
    variables: { catererId: menuToImportCatererId },
    enabled,
    skip: !menuToImportCatererId
  });

  const [createMenuWithAddOns] = useMutation(CREATE_MENU_WITH_ADDONS, {
    onError: (err) => {
      toggleSnackbar({
        status: true,
        message: err.message || "Error occurred while creating menu item",
        variant: "error",
      });
    }
  });

  const catererId = props?.catererId;
  const catererData = props?.catererData;

  const fetchMenu = () => {
    setEnabled(true);
    refetch();
  };

  const importMenuFromCaterer = async () => {
    if (!menu?.data?.length) {
      return;
    }

    setImportProgress(menu.data.map(item => ({ name: item.itemName, status: 'pending' })));

    try {
      await Promise.all(menu.data.map(async (item) => {
        const { addOnTypeList: rawTypes = [] } = item;
        
        const validAddOnTypes = (Array.isArray(rawTypes) && rawTypes.length > 0)
          ? rawTypes.map(type => {
              const validAddOns = Array.isArray(type.addOnsList)
                ? type.addOnsList.map(addOn => {
                    const validSubAddOns = Array.isArray(addOn.subAddOnsList)
                      ? addOn.subAddOnsList.map(sub => ({
                          name:      sub.subAddOnName,
                          price:     sub.subAddOnPrice,
                          sortOrder: sub.subSortOrder
                        }))
                      : [];
                    return {
                      name:      addOn.addOnName,
                      price:     addOn.addOnPrice,
                      sortOrder: addOn.addOnSortOrder,
                      subAddOns: validSubAddOns
                    };
                  })
                : [];
                
              let choiceType = "Multiple";
              let limit = 3;
              
              if (type.type) {
                choiceType = type.type;
              } else if (type.choiceType) {
                choiceType = type.choiceType;
              }
              
              if (type.addOnTypeLimit) {
                limit = type.addOnTypeLimit;
              } else if (type.maxSelection) {
                limit = type.maxSelection;
              }
              
              return {
                name:       type.addOnTypeName,
                sortOrder:  type.sortOrder,
                choiceType: choiceType,
                limit:      limit,
                addOns:     validAddOns
              };
            })
          : undefined;

        const itemInput = {
          itemName: item.itemName,
          order: item.order,
          categoryId: item.categoryId,
          dietory: item.dietory,
          itemDescription: item.itemDescription,
          markasPopularFlg: item.markasPopularFlg,
          additionalPkdPrice: item.additionalPkdPrice,
          offerIndPkdFlg: item.offerIndPkdFlg,
          price: item.price,
          minQuantity: item.minQuantity,
          itemType: item.itemType,
          itemPkgType: item.itemPkgType,
          itemImage: item.itemImage,
          catererId: catererId,
          ...(validAddOnTypes && validAddOnTypes.length > 0 ? { addOnTypes: validAddOnTypes } : {})
        };

        await createMenuWithAddOns({ variables: { data: itemInput } });

        setImportProgress(prev => prev.map(p => p.name === item.itemName ? { ...p, status: 'done' } : p));
      }));

      toggleSnackbar({
        status: true,
        message: `${menu.data.length} menu items imported successfully`,
        variant: "success",
      });

      props.setOpenImportMenu(false);
      window.location.reload();
    } catch (e) {
      toggleSnackbar({
        status: true,
        message: e.message || "Error occurred while importing menu items",
        variant: "error",
      });
    }
  };

  useEffect(() => {
    if (enabled && data?.listMenu) {
      setMenu(data?.listMenu);
      setFromCaterer(data?.listMenu?.catererData);
    }
  }, [enabled, data]);

  return (
    <Drawer
      className="common-drawer"
      anchor={"right"}
      open={props.openImportMenu}
      onClose={() => { props.setOpenImportMenu(false); }}
    >
      <div className="drawer-head">
        <h4 className="h4">
          Import Menu
        </h4>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => { props.setOpenImportMenu(false); }}
        >
          <img
            src="../assets/images/x-icon.svg"
            className="img-fluid"
            alt="close icon"
          />
        </span>
      </div>

      <form
        onSubmit={() => console.log('sup')}
        noValidate
      >
        <div className="container py-2">
          <div className="row">
            { !menu &&
              <div className="col-12">
                <input
                    placeholder="Input catererId"
                    className="form-control align-right"
                    onChange={(e) => {
                      setMenuToImportCatererId(e.target.value)
                    }}
                  />
                <Button
                  variant="contained"
                  color="primary"
                  className="w-100 mt-2"
                  onClick={fetchMenu}>Fetch Menu</Button>
              </div>
            }

            { menu &&
              <div className="col-12">
                <div>Menu found with item count: <strong>{menu?.count}</strong></div>
                <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
                  {menu?.data?.map((item, i) => (
                    <li
                      key={i}
                      style={{ marginBottom: '8px', fontSize: '16px', color: '#333' }}
                    >
                      {item.itemName}
                      {item.type && (
                        <> ({item.type} Choice{item.addOnTypeLimit ? `, limit: ${item.addOnTypeLimit}` : ''})</>
                      )}
                    </li>
                  ))}
                </ul>
                <div>Do you want to import menu from <u>{fromCaterer?.businessName || fromCaterer?._id}</u> to <u>{catererData?.businessName || catererId}</u>?</div>
                <Button
                  variant="contained"
                  color="primary"
                  className="w-100 mt-2"
                  onClick={importMenuFromCaterer}>Yes</Button>
                {importProgress.length > 0 &&
                  <div className="mt-3">
                    <h5>Import Progress</h5>
                    <ul>
                      {importProgress.map((p, idx) => (
                        <li key={idx}>
                          {p.name} - {p.status}
                        </li>
                      ))}
                    </ul>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div className="createStepBtn">
          <Button
            className="cancelBtn"
            variant="contained"
            color="secondary"
            onClick={() => { props.setOpenImportMenu(false); setMenu(null); setMenuToImportCatererId(null); }}
          >
            Cancel
          </Button>
        </div>
      </form>

    </Drawer >
  );
}
